import React, { useEffect, useState } from "react";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import styles from "./NewSingleQueryPopup.module.scss";
import locationIcon from "../../assets/images/location_icon.png";
import destinationIcon from "../../assets/images/experienc_icon.png";
import securityIcon from "../../assets/images/security_icon.png";
import customerIcon from "../../assets/images/customer_icon.png";
import MultiSelectInputSingleId from "../MultiSelectInputSingleId/MultiSelectInputSingleId";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { calculateToDatePlus } from "../../utils/utils";
import queryImg from "../../assets/new-images/query-image.png";

const PackageQueryForm = ({
  package_id,
  setshowRatePopup,
  typeDetail,
  packageData,
  guest,
  selectedCategory,
  children,
  childAge,
}) => {
  const [showRatePopup, setShowRatePopup] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const userType = localStorage.getItem("userType");

  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    travel_date: "",
    start_date_information: "",
    end_date_information: "",
    end_Date: "",
    source: "website",
    adult: "",
    children_information: "",
    time: "",
    content: "",
    source_type: "",
    guide_required: "",
    hotel_category_information: "",
    room_category_information: "",
    type: typeDetail ? typeDetail : "package",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleShowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(false);
  };

  const postDataHandle = (e) => {
    e.preventDefault();
    const myHeaders = new Headers();
    const valid = validate();
    setTimeout(() => {
      setFormErrors({});
    }, 1500);
    if (!valid) {
      showErrorToast("Please fill the required details");
      return;
    }

    setTimeout(() => {
      setFormErrors({});
    }, 1000);

    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);

    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      leadName: formData?.company_name,

      leadPhone: formData?.phone,

      leadSubject: formData?.subject,

      leadEmail: formData?.email,

      package_id: package_id,

      leadDetail: formData?.querry_detail,

      leadSource: "Website",

      query_company: formData?.name,

      query_type: "agent",

      travel_date: formData?.travel_date,

      leadSubject: "Enquiry",

      type: typeDetail ? typeDetail : "",

      adult: formData?.adult,

      time: formData?.time,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_APP_URL}/api/v1/send-query`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          showSuccessToast("Enquiry sent successfully");

          setTimeout(() => {
            window.location.reload();
          }, 200);

          setShowRatePopup(false);
        }
      })

      .catch((error) => console.error(error));
  };

  const validate = () => {
    const errors = {};
    // Add validation logic for each form field
    // if (currentStep === 1) {
    if (!formData.name.trim()) {
      errors.name = "required";
    }
    if (!formData.company_name.trim()) {
      errors.company_name = "required";
    }
    if (!formData.phone.trim()) {
      errors.phone = "is required";
    }
    if (!formData.querry_detail) {
      errors.querry_detail = "required";
    }
    if (!formData.email) {
      errors.email = "required";
    }
    if (!formData.travel_date) {
      errors.travel_date = "required";
    }
    // }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const baseUrl =
    "https://www.mountainmysteries.com" + window?.location?.pathname;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const destinationIds = packageData?.packageDestination?.map(
      (dest) => dest.destinationId
    );

    const firstDestination =
      destinationIds?.length > 0 ? destinationIds[0] : null;
    const lastDestination =
      destinationIds?.length > 0
        ? destinationIds[destinationIds.length - 1]
        : null;

    const sourceType =
      userType === "agent"
        ? "agent"
        : userType === "vendor"
        ? "vendor"
        : "customer";

    const rawData = {
      name: formData?.name,
      email: formData?.email,
      phone_information: formData?.phone,
      travel_date_information: formData?.travel_date,
      guide_required_information: formData?.guide_required,
      content: formData?.content,
      source: formData?.source,
      source_type: sourceType,
      type: formData?.type,

      adults_information: guest ? guest : 2,
      children_information: children,
      child_age_information: childAge,
      // start_date_information: formData.start_date_information,
      // end_date_information: formData.end_date_information,

      start_date_information: formData.start_date_information
        ? format(formData.start_date_information, "yyyy-MM-dd")
        : "",
      end_date_information: formData.end_date_information,
      // end_date_information: formData.end_date_information
      //     ? format(formData.end_date_information, 'yyyy-MM-dd')
      //     : "",

      hotel_category_information: [selectedCategory],
      room_category_information: [selectedCategory],
      destination_start_information: firstDestination,
      destination_end_information: lastDestination,
      all_destinations_information: destinationIds,
      package_name_information: packageData?.packageName,
      package_id_information: packageData?.packageId,
      package_url_information: baseUrl,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/query/create`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(rawData),
          redirect: "follow",
        }
      );
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message || "Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          travel_date: "",
          adult: "",
          time: "",
          source: "website",
          content: "",
          source_type: "",
        });
        setshowRatePopup(false);
      } else {
        showErrorToast(
          result.message || "An error occurred. Please try again."
        );
        // setFormData({
        //     name: "",
        //     email: "",
        //     phone: "",
        //     travel_date: "",
        //     adult: "",
        //     time: "",
        //     source: "website",
        //     content: "",
        //     source_type: "",
        // });
      }
    } catch (error) {
      showErrorToast("An error occurred. Please try again.");
      console.error(error);
    }
  };

  // const fetchDestinations = async () => {
  //     setLoader(true);
  //     const myHeaders = new Headers();
  //     myHeaders.append("Accept", "application/json");
  //     myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
  //     const formData = new FormData();
  //     // formData.append("limit", 10);

  //     const requestOptions = {
  //         method: "POST",
  //         headers: myHeaders,
  //         redirect: "follow",
  //         body: formData,
  //     };

  //     try {
  //         const response = await fetch(
  //             `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
  //             requestOptions
  //         );
  //         if (!response.ok) {
  //             throw new Error(`HTTP error! Status: ${response.status}`);
  //         }
  //         const result = await response.json();
  //         setDestinationData(result?.data);
  //     } catch (error) {
  //         console.error("Error fetching data:", error);
  //     } finally {
  //         setLoader(false);
  //     }
  // };

  // useEffect(() => {
  //     fetchDestinations();
  // }, []);

  // console.log(destinationData, 'destinationData');

  const AccommodationCategoryOptions = [
    {
      label: "Budget",
      value: "budget",
      id: "budget",
    },
    {
      label: "Standard",
      value: "standard",
      id: "standard",
    },
    {
      label: "Deluxe",
      value: "deluxe",
      id: "deluxe",
    },
    {
      label: "Super Deluxe",
      value: "super-deluxe",
      id: "super-deluxe",
    },
    {
      label: "Luxury",
      value: "luxury",
      id: "luxury",
    },
    {
      label: "Premium",
      value: "premium",
      id: "premium",
    },
  ];

  const RoomCategoryOptions = [
    {
      label: "Budget",
      value: "budget",
      id: "budget",
    },
    {
      label: "Standard",
      value: "standard",
      id: "standard",
    },
    {
      label: "Deluxe",
      value: "deluxe",
      id: "deluxe",
    },
    {
      label: "Super Deluxe",
      value: "super-deluxe",
      id: "super-deluxe",
    },
    {
      label: "Luxury",
      value: "luxury",
      id: "luxury",
    },
    {
      label: "Premium",
      value: "premium",
      id: "premium",
    },
  ];

  return (
    <div className="bg-backdrop packagequery_form_backdrop">
      <div className={styles.soldout_popup}>
        {" "}
        <div className={styles.new_popup_flex}>
          <div className={styles.new_popup_colored}>
            <div className="flex align_items_center h-full justify_content_center flex-col">
              <div style={{ width: "80%" }}>
                {" "}
                <img src={queryImg} alt="banner image" />
              </div>
              <h4 style={{color:"#fff", textAlign:"center", marginTop:"10px"}}>Our expert Will get in Touch with you shortly</h4>
            </div>
          </div>
          <form onSubmit={handleSubmit} className={styles.new_popup_form}style={{paddingTop:"20px"}}>
            <h4
              style={{
                fontSize: "20px",
                fontWeight: "500",
                color: "#333",
                textAlign: "left",
              }}
            >
              Enter Your Details
            </h4>
            <div
              className="dashboard_checkin_modal_close_btn"
              onClick={handleShowRatePopup}
              style={{
                cursor: "pointer",
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M1 12.7464L13 0.851318"
                  stroke="#AAAAAA"
                  strokeWidth="1.2"
                />
                <path
                  d="M13 12.7463L0.999999 0.851296"
                  stroke="#AAAAAA"
                  strokeWidth="1.2"
                />
              </svg>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <div className="flex flex_gap_10">
                <div className={styles.package_query_input_50} style={{width:"50%"}}>
                  <label htmlFor="name">Name:</label>
                  <input
                    // required
                    className="w-full"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Name"
                    style={{
                      padding: "5px",
                      borderRadius: "0px",
                      border: "1px solid #333",
                      ...(formErrors.name && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                    required
                  />
                </div>
                <div className={styles.package_query_input_50} style={{width:"50%"}}>
                  <label htmlFor="phone">Phone:</label>
                  <input
                    className="w-full"
                    type="number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone"
                    style={{
                      padding: "5px",
                      borderRadius: "0px",
                      border: "1px solid #333",
                      ...(formErrors.phone && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                    required
                  />
                </div>
              </div>

              <div className={styles.email_travel_input}>
                <div className={styles.package_query_input_100} style={{width:"50%"}}>
                  <label htmlFor="email">Email:</label>
                  <input
                    className="w-full"
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email"
                    style={{
                      padding: "5px",
                      borderRadius: "0px",
                      border: "1px solid #333",
                      ...(formErrors.email && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                    required
                  />
                </div>
                <div className={styles.package_query_input_100} style={{width:"50%"}}>
                  <label htmlFor="start_date_information">Travel Date:</label>
                  {/* <input
                                    className="w-full"
                                    type="date"
                                    name="start_date_information"
                                    value={formData.start_date_information}
                                    onChange={handleInputChange}
                                    min={new Date().toISOString().split("T")[0]}
                                    placeholder="Start Date"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        ...(formErrors.start_date_information && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                /> */}

                  <div className={styles.new_date_picker_wrapper}>
                    <DatePicker
                      selected={formData?.start_date_information}
                      // onChange={(date) => setFormData(date)}
                      onChange={(date) => {
                        setFormData((prev) => ({
                          ...prev,
                          start_date_information: date,
                          end_date_information: calculateToDatePlus(
                            date,
                            packageData?.totalDays + 1
                          ),
                        }));
                      }}
                      portalId="root-portal NewUIReactDatePicker PackageQueryFormDatePickerWrapper"
                      popperPlacement="bottom-start"
                      className="queryinput"
                      minDate={new Date()}
                      dateFormat="dd MMM, yyyy"
                      placeholderText={
                        formData?.start_date_information
                          ? format(
                              formData?.start_date_information,
                              "dd MMM, yyyy"
                            )
                          : "Travel Date"
                      }
                      style={{
                        padding: "5px",
                        borderRadius: "0px",
                        border: "1px solid #333",
                      }}
                    />
                  </div>
                </div>
                {/* <div className={styles.package_query_input_50}>
                                <label htmlFor="source_type">Are you Agent:</label>
                                <select
                                    style={{
                                        padding: "10px",
                                        ...(formErrors.source_type && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                    className="w-full"
                                    name="source_type"
                                    value={formData.source_type}
                                    onChange={handleInputChange}
                                >
                                    <option value="" disabled>
                                        Select an option
                                    </option>
                                    <option value="agent">Yes</option>
                                    <option value="customer">No</option>
                                </select>
                            </div> */}
              </div>

              <div className="flex flex_gap_10">
                {/* <div className={styles.package_query_input_50}>
                                <label htmlFor="end_date_information">End Date:</label>
                                <div className={styles.new_date_picker_wrapper}>
                                    <DatePicker
                                        selected={formData?.end_date_information}
                                        // onChange={(date) => setFormData(date)}
                                        onChange={(date) => setFormData(prev => ({
                                            ...prev,
                                            end_date_information: date
                                        }))}
                                        portalId="root-portal NewUIReactDatePicker PackageQueryFormDatePickerWrapper"
                                        popperPlacement="bottom-start"
                                        className="PackageQueryFormDatePickerWrapper2"
                                        minDate={new Date()}
                                        dateFormat="dd MMM, yyyy"
                                        placeholderText={
                                            formData?.end_date_information ? format(formData?.end_date_information, "dd MMM, yyyy") : "End Date"
                                        }
                                    />
                                </div>
                            </div> */}
              </div>

              {/* 

                            <div className={styles.package_query_input_33}>
                                <label htmlFor="start_destination">Start Destination:</label>
                                <select
                                    style={{
                                        padding: "10px",
                                        ...(formErrors.start_destination && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                    className="w-full"
                                    name="start_destination"
                                    value={formData.start_destination}
                                    onChange={handleInputChange}
                                >
                                    <option value="">
                                        Select an option
                                    </option>
                                    {destinationData && destinationData.slice(0, 10)?.map((item) => (
                                        <option value={item.name}>{item.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className={styles.package_query_input_33}>
                                <label htmlFor="end_destinnation">End Destination:</label>
                                <select
                                    style={{
                                        padding: "10px",
                                        ...(formErrors.end_destination && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                    className="w-full"
                                    name="end_destination"
                                    value={formData.end_destination}
                                    onChange={handleInputChange}
                                >
                                    <option value="">
                                        Select an option
                                    </option>
                                    {destinationData && destinationData.map((item) => (
                                        <option value={item.name}>{item.name}</option>
                                    ))}
                                </select>
                            </div> */}

              {/* <div className={styles.package_query_input_33}>
                                <MultiSelectInputSingleId
                                    selectById={true}
                                    showById={false}
                                    multiSelectInputData={AccommodationCategoryOptions}
                                    getDataFromMultiSelectInput={(data) => {
                                        console.log("data", data);
                                        setFormData({
                                            ...formData,
                                            hotel_category_information: data,
                                        });
                                    }}
                                    value={formData?.hotel_category_information}
                                    label="Hotel Categories"
                                />
                            </div>
                            <div className={styles.package_query_input_33}>
                                <MultiSelectInputSingleId
                                    selectById={true}
                                    showById={false}
                                    multiSelectInputData={RoomCategoryOptions}
                                    getDataFromMultiSelectInput={(data) => {
                                        console.log("data", data);
                                        setFormData({
                                            ...formData,
                                            room_category_information: data,
                                        });
                                    }}
                                    value={formData?.room_category_information}
                                    label="Room Categories"
                                />
                            </div>

                            <div className={styles.package_query_input_33}>
                                <MultiSelectInputSingleId
                                    selectById={true}
                                    showById={false}
                                    multiSelectInputData={allDestinationsArray}
                                    getDataFromMultiSelectInput={(data) => {
                                        console.log("data", data);
                                        setFormData({
                                            ...formData,
                                            all_destinations_information: data,
                                        });
                                    }}
                                    value={formData?.all_destinations_information}
                                    label="All Destinations"
                                />
                            </div> */}

              {/* <div className="flex flex_gap_10">
                            <div className={styles.package_query_input_33}>
                                <label htmlFor="source_type">Adult:</label>
                                <input
                                    className="w-full"
                                    type="number"
                                    name="adult"
                                    value={formData.adult}
                                    onChange={handleInputChange}
                                    placeholder="Adult"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        ...(formErrors.adult && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                />
                            </div>
                            <div className="activity_inputs_query_forms">
                                <label htmlFor="source_type">Children:</label>
                                <input
                                    className="w-full"
                                    type="number"
                                    name="children"
                                    value={formData.children_information}
                                    onChange={handleInputChange}
                                    placeholder="Children"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        ...(formErrors.children && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                />
                            </div>
                        </div> */}

              {/* {typeDetail === "activity" && (
                            <div className="flex flex_gap_10">
                                <div className="activity_inputs_query_forms">
                                    <label htmlFor="guide_required">Do you need Guide:</label>
                                    <select
                                        style={{
                                            padding: "10px",
                                            ...(formErrors.guide_required && {
                                                backgroundColor: "#ff000040",
                                                border: "1px solid red",
                                            }),
                                        }}
                                        className="w-full"
                                        name="guide_required"
                                        value={formData.guide_required}
                                        onChange={handleInputChange}
                                    >
                                        <option value="" disabled>
                                            Select an option
                                        </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                                <div className="activity_inputs_query_forms">
                                    <label htmlFor="source_type">Time:</label>
                                    <input
                                        className="w-full"
                                        type="time"
                                        name="time"
                                        value={formData.time}
                                        onChange={handleInputChange}
                                        placeholder="Time"
                                        style={{
                                            padding: "10px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                            ...(formErrors.time && {
                                                backgroundColor: "#ff000040",
                                                border: "1px solid red",
                                            }),
                                        }}
                                    />
                                </div>
                            </div>
                        )} */}

              <div className={styles.package_query_input_100}>
                <label htmlFor="content">Query Detail:</label>
                <textarea
                  className="w-full"
                  type="text-area"
                  name="content"
                  value={formData.content}
                  onChange={handleInputChange}
                  placeholder="Querry Detail"
                  style={{
                    padding: "5px",
                    borderRadius: "0px",
                    border: "1px solid #333",
                    margin: "5px 0",
                    ...(formErrors.content && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                />
              </div>
              <div className="">
                <button type="submit" className={styles.common_btn}>
                  Send{" "}
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_8264_9427"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="16"
                      height="17"
                    >
                      <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_8264_9427)">
                      <path d="M10.7832 9.16674H3.33317C3.14428 9.16674 2.98595 9.10285 2.85817 8.97507C2.73039 8.8473 2.6665 8.68896 2.6665 8.50007C2.6665 8.31118 2.73039 8.15285 2.85817 8.02507C2.98595 7.89729 3.14428 7.83341 3.33317 7.83341H10.7832L7.5165 4.56674C7.38317 4.43341 7.31928 4.27785 7.32484 4.10007C7.33039 3.9223 7.39984 3.76674 7.53317 3.63341C7.6665 3.51118 7.82206 3.4473 7.99984 3.44174C8.17762 3.43618 8.33317 3.50007 8.4665 3.63341L12.8665 8.03341C12.9332 8.10007 12.9804 8.1723 13.0082 8.25007C13.0359 8.32785 13.0498 8.41118 13.0498 8.50007C13.0498 8.58896 13.0359 8.6723 13.0082 8.75007C12.9804 8.82785 12.9332 8.90007 12.8665 8.96674L8.4665 13.3667C8.34428 13.489 8.1915 13.5501 8.00817 13.5501C7.82484 13.5501 7.6665 13.489 7.53317 13.3667C7.39984 13.2334 7.33317 13.0751 7.33317 12.8917C7.33317 12.7084 7.39984 12.5501 7.53317 12.4167L10.7832 9.16674Z" />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PackageQueryForm;
